exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.is-invalid[data-v-54212176] {\n  border:1px solid red;\n}\n", ""]);

// exports
